module.exports = __webpack_public_path__ + "media/styles/images/png/pencil-white-c621776c7d8fe803a71026fa82199fd4.png";